import {
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  differenceInWeeks,
} from 'date-fns';

import { SmsConversationType } from './types';

export const getTalentName = (conversation: SmsConversationType) => {
  const firstName = conversation.talent?.first_name_abac?.value || '';
  const lastName = conversation.talent?.last_name_abac?.value || '';
  return `${firstName} ${lastName}`.trim() || 'Unknown';
};

export const getLastMessagePreview = (message: string | null | undefined) => {
  if (!message) return 'No messages yet';
  return message.length > 50 ? `${message.slice(0, 50)}...` : message;
};

export const getFormattedDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    const now = new Date();

    const seconds = differenceInSeconds(now, date);
    if (seconds < 60) return 'now';

    const minutes = differenceInMinutes(now, date);
    if (minutes < 60) return `${minutes}m`;

    const hours = differenceInHours(now, date);
    if (hours < 24) return `${hours}h`;

    const days = differenceInDays(now, date);
    if (days < 7) return `${days}d`;

    const weeks = differenceInWeeks(now, date);
    return `${weeks}w`;
  } catch {
    return '';
  }
};
